import React from "react";
import { useState, useRef, useEffect } from "react";
import "./PnLFloorplanDetailsCallout.scss";

function plus(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={9}
            height={10}
            fill="none"
            {...props}
        >
            <path
                stroke="#000"
                strokeLinejoin="round"
                strokeWidth={0.727}
                d="M4.364 0v9.33M0 4.665h8.727"
            />
        </svg>
    );
}

function triangle(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={9}
            fill="none"
            {...props}
        >
            <path fill="#F3FAD2" d="m4.763 0 4.763 8.25H0L4.763 0Z" />
        </svg>
    );
}

function PnLFloorplanDetailsCallout(props) {
    var [open, setOpen] = useState(false);
    var classes = "PnLFloorplanDetailsCallout";
    //add the positioning classes
    var anchorClass = `anchor-${props.callout.anchor_point}`;
    var sideClass = `display-side-${props.callout.display_side}`;
    var boxClass = `box-${props.callout.box_size}`;
    if (open) classes += " open";
    var container = useRef();

    classes +=
        " " +
        anchorClass +
        " " +
        sideClass +
        " " +
        boxClass +
        " type-" +
        props.type;

    var styles = {
        top: `${props.callout.position.top}%`,
        left: `${props.callout.position.left}%`,
        zIndex: `${60 - props.index}`,
    };

    function toggleCallout() {
        setOpen(!open);
    }

    useEffect(() => {
        function forceMessageWindowIntoContentFrame() {
            var containerRect = container.current.getBoundingClientRect();

            //if (window.innerWidth < 640) {
            if (containerRect.right > window.innerWidth) {
                //over on the right side
                var adjustAmount = containerRect.right - window.innerWidth + 12;
                container.current.style.position = "relative";
                container.current.style.left = "-" + adjustAmount + "px";
            } else if (containerRect.left < 0) {
                //need to do what we did on the right side
                var adjustAmount = containerRect.left;
                if (adjustAmount < 0) adjustAmount *= -1;
                adjustAmount += 12;
                container.current.style.position = "relative";
                container.current.style.left = adjustAmount + "px";
            } else {
                container.current.style.position = "";
                container.current.style.left = "";
            }
        }

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    forceMessageWindowIntoContentFrame();
                });
            });
        });
        window.addEventListener("resize", forceMessageWindowIntoContentFrame);

        return () => {
            container.current.style.position = "";
            container.current.style.left = "";
            window.removeEventListener(
                "resize",
                forceMessageWindowIntoContentFrame
            );
        };
    });

    return (
        <div className={classes} style={styles}>
            <button className="toggle" onClick={toggleCallout}>
                {plus()}
            </button>
            <div class="message-wrapper">
                <div
                    class="message-container"
                    ref={container}
                    dangerouslySetInnerHTML={{ __html: props.callout.message }}
                ></div>
                {triangle()}
            </div>
        </div>
    );
}

export default PnLFloorplanDetailsCallout;
